export const RXDB_DATABASE_NAME = "oboku-53"
